import { render, staticRenderFns } from "./UserRecordDialog.vue?vue&type=template&id=1de9c2f2&scoped=true&"
import script from "./UserRecordDialog.vue?vue&type=script&lang=js&"
export * from "./UserRecordDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de9c2f2",
  null
  
)

export default component.exports